export class DealBuilder {

	build(data) {
		let self = this;
		/** ${self.buildPersonallyVerified(data)} was commented out because this label moved to top in favour of favoriting */

		/** ${self.buildCircleLabels(data)}  - this is removed from under the buildLabels method */
		return `
			<div class="col-lg--6-12 col-md-wide--12-12">
				<article class="c-tk-deal-card">
					<a class="c-tk-deal-card__flex" href="${data['link']}">
						<div class="c-tk-deal-card__top">
							<!-- HEADER -->
							<header class="c-tk-deal-card__header">
								<figure class="c-tk-deal-card__image c-lazy-image">
									<img class="c-lazy-image__placeholder" src="${data['image_lazy']}" alt="${data['image_alt']}">
									<img class="c-lazy-image__image js-lazy-image" data-src="${data['image_src']}" data-srcset="${data['image_srcset']}" alt="${data['alt']}">

									<noscript>
										<img src=${data['image_src']}" alt="${data['alt']}">
									</noscript>
								</figure>

								<!-- PRICE -->
								${self.buildPrices(data)}

								<!-- FAVOURITE -->
								${self.buildFavorite(data)}
							</header>

							<div class="c-tk-deal-card__content">
								<!-- LABELS -->
								${self.buildLabels(data)}

								<!-- TITLE -->
								<h2 class="c-tk-deal-card__headline">${data['miniName']}</h2>

								<!-- RATING / NEW LABEL / HOTEL NAME -->
								<div>
									<span class="c-tk-deal-card__rating">
										<svg width="12" height="12" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
											<title>star-score-fill-icon</title>
											<desc>Created with Sketch.</desc>
											<path d="M8.378.264l2.035 5.051 5.21.469c.361.033.508.506.234.754l-3.952 3.591 1.184 5.341c.082.371-.301.663-.612.466l-4.478-2.832-4.478 2.832c-.311.196-.694-.096-.612-.466l1.184-5.341-3.953-3.591c-.274-.249-.128-.722.234-.754l5.21-.469 2.035-5.05c.141-.351.615-.351.756 0z" fill="#FFA82C" fill-rule="nonzero"></path>
										</svg>
										<span>${data['review_public'] ? data['review_public'] : data['newsLabel']}</span>
									</span>

									<!-- HOTEL NAME -->
									<span class="c-tk-deal-card__place">${data['hotelName']}</span>
								</div>

								<!-- LOCATION -->
								<span class="c-tk-deal-card__sub-headline">${data['location_text']}</span>

								<!-- PERSONS -->
								<span class="c-tk-deal-card__sub-headline">${data['people_days_text']}</span>

								${self.buildVerificationLabels(data)}
							</div>
						</div>
					</a>
				</article>
			</div>
		`;
	}

	buildCottage(data) {
		let self = this;
		/** ${self.buildPersonallyVerified(data)} was commented out because this label moved to top in favour of favoriting */

		/** ${self.buildCircleLabels(data)}  - this is removed from under the buildLabels method */

		return `
			<div class="col-lg--6-12 col-md-wide--12-12">
				<article class="c-deal-card c-deal-card--building">
					<a class="c-deal-card__flex" href="${data['detail_url']}">
						<div class="c-deal-card__top">
							<header class="c-deal-card__header">
                 				${self.buildCottagePhotos(data)}
								<div class="c-deal-card__price c-price">
									<span class="c-price__old" style="text-decoration: none">
										${data['price_cottage_night_text']}
									</span>
									<span class="c-price__new">
										${data['price_cottage_night']}
									</span>
								</div>
								${self.buildFavorite(data['favorites'])}
							</header>
							<div class="c-deal-card__content">
								<h2 class="c-deal-card__headline">
									${data['name']}
								</h2>
								<p class="c-deal-card__location c-icon-with-text">
									<span class="icon-svg icon-svg__icon-location-cz" aria-hidden="true">
										<svg class="icon-svg__svg" viewBox="0 0 22 22" width="22" height="22">
											<use xlink:href="${data['location_ico']}"></use>
										</svg>
									</span>
									<span class="c-icon-with-text__text">${data['address']}</span>
								</p>
								<div class="c-deal-card__content-divider"></div>
								<div class="c-deal-card__summary">
									<div class="c-deal-card__summary-left">
										<span class="c-deal-card__summary-line">
											<strong class="c-deal-card__summary-label">
												${data['persons_text']}:
											</strong>
											<span class="c-deal-card__summary-value">
												${data['persons']}
											</span>
										</span>
										<span class="c-deal-card__summary-line">
											<strong class="c-deal-card__summary-label">
												${data['bedrooms_text']}:
											</strong>
											<span class="c-deal-card__summary-value">
												${data['bedrooms']}
											</span>
										</span>
									</div>
									<div class="c-deal-card__summary-right">
										<span class="c-deal-card__summary-line">
											<strong class="c-deal-card__summary-label">
												${data['price_week_text']}:
											</strong>
											<span class="c-deal-card__summary-value">
												${data['price_week']}
											</span>
										</span>
										<span class="c-deal-card__summary-line">
											<strong class="c-deal-card__summary-label">
												${data['price_person_night_text']}:
											</strong>
											<span class="c-deal-card__summary-value">
												${data['price_person_night']}
											</span>
										</span>
									</div>
								</div>
							</div>
						</div>
						<footer class="c-deal-card__footer">
							<div class="c-deal-card__footer-line">
								${self.buildCottageIcons(data['icons1'])}
							</div>
							<div class="c-deal-card__footer-line">
								${self.buildCottageIcons(data['icons2'])}
							</div>
						</footer>
					</a>
				</article>
			</div>
		`;
	}

	buildCottageIcons(icons) {
		let html = '';
		for (let key in icons) {
			let icon = icons[key];
			html += `<span class="c-icon-with-text">
						<span class="icon-svg icon-svg__icon-{{ $icon['icon'] }}" aria-hidden="true">
							<svg class="icon-svg__svg" viewBox="0 0 36 36" width="36" height="36">
								<use xlink:href="${icon['icon']}"></use>
							</svg>
						</span>
						<span class="c-icon-with-text__text">
							${icon['text']}
						</span>
					</span>`;
		}

		return html;
	}

	buildCottagePhotos(data) {
		let html = '';

		if (data['is_mobile'] === true) {
			let photo = data['photos'][0];
			html += `<figure class="c-deal-card__image c-lazy-image">
						<img class="c-lazy-image__placeholder" src="${photo['image_placeholder']}">
						<img class="c-lazy-image__image js-lazy-image" data-src="${photo['image_full']}" data-srcset="${photo['image_srcset']}" alt="${photo['image_alt']}">
						<noscript>
							<img src="${photo['image_full']}" alt="${photo['image_alt']}">
						</noscript>
					</figure>`;
		} else {
			html += `<ul class="c-slider__inside js-slider" data-items="1" data-autoplay="false">`;
			for (let key in data['photos']) {
				let photo = data['photos'][key];
				html += `<li class="c-slider__item">
							<figure class="c-deal-card__image c-lazy-image">
								<img class="c-lazy-image__placeholder" src="${photo['image_placeholder']}">
								<img class="c-lazy-image__image js-lazy-image" data-src="${photo['image_full']}" data-srcset="${photo['image_srcset']}" alt="${photo['image_alt']}">
								<noscript>
									<img src="${photo['image_full']}" alt="${photo['image_alt']}">
								</noscript>
							</figure>
						</li>`;
			}
			html += `</ul>`;
		}

		return html;
	}

	/**
	 * Labels are no longer used/shown - only online reservations
	 */
	buildLabels(data) {
		let html = '';

		html += '<div class="c-tk-deal-card__labels">';

		// Price before
		if (data['price_before']) {
			html += `<div class="c-tk-deal-card__labels-item ${data['price_before']['cssClass']}">
                                ${data['price_before']['icon']}
                                <span>
                                    ${data['price_before']['title'].replace('<br>', '')}
                                </span>
                            </div>`;
		}

		// FKSP
		if (data['isFksp']) {
			html += `<div class="c-tk-deal-card__labels-item c-tk-deal-card__labels-item--orange">
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 10.2V9.15004H9.85714C8.67557 9.15004 7.71429 8.20798 7.71429 7.05003C7.71429 5.89209 8.67557 4.95002 9.85714 4.95002H12V3.90002C12 3.32083 11.5191 2.85001 10.9286 2.85001H1.71429C1.47814 2.85001 1.28571 2.66185 1.28571 2.43001C1.28571 2.19817 1.47814 2.01001 1.71429 2.01001H9.64286C9.99814 2.01001 10.2857 1.72776 10.2857 1.38C10.2857 1.03224 9.99814 0.75 9.64286 0.75H1.71429C0.768857 0.75 0 1.50348 0 2.43001V9.57004C0 10.4966 0.768857 11.2501 1.71429 11.2501H10.9286C11.5191 11.2501 12 10.7792 12 10.2ZM11.9999 8.3103V5.79028H9.857C9.14686 5.79028 8.57129 6.35435 8.57129 7.05029C8.57129 7.74623 9.14686 8.3103 9.857 8.3103H11.9999Z" fill="currentColor"/>
                                </svg>
                                 <span>${data['isFkspText']}</span>
                            </div>`;
		}

		// Accepts recreation vouchers
		if (data['recreationVoucher']) {
			html += `<div class="c-tk-deal-card__labels-item c-tk-deal-card__labels-item--orange">
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 10.2V9.15004H9.85714C8.67557 9.15004 7.71429 8.20798 7.71429 7.05003C7.71429 5.89209 8.67557 4.95002 9.85714 4.95002H12V3.90002C12 3.32083 11.5191 2.85001 10.9286 2.85001H1.71429C1.47814 2.85001 1.28571 2.66185 1.28571 2.43001C1.28571 2.19817 1.47814 2.01001 1.71429 2.01001H9.64286C9.99814 2.01001 10.2857 1.72776 10.2857 1.38C10.2857 1.03224 9.99814 0.75 9.64286 0.75H1.71429C0.768857 0.75 0 1.50348 0 2.43001V9.57004C0 10.4966 0.768857 11.2501 1.71429 11.2501H10.9286C11.5191 11.2501 12 10.7792 12 10.2ZM11.9999 8.3103V5.79028H9.857C9.14686 5.79028 8.57129 6.35435 8.57129 7.05029C8.57129 7.74623 9.14686 8.3103 9.857 8.3103H11.9999Z" fill="currentColor"/>
                                </svg>
                                 <span>${data['recreationVoucherText']}</span>
                            </div>`;
		}

		// Weekly tip
		if (data['weekly_tip']) {
			html += ` <div class="c-tk-deal-card__labels-item c-tk-deal-card__labels-item--orange">
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.7507 8.99862L7.51165 1.20621C6.83058 0.059628 5.17033 0.0581046 4.48835 1.20621L0.249536 8.99862C-0.446698 10.1702 0.396232 11.6539 1.76083 11.6539H10.239C11.6025 11.6539 12.4469 10.1714 11.7507 8.99862ZM6 10.2476C5.61239 10.2476 5.29687 9.93211 5.29687 9.5445C5.29687 9.15689 5.61239 8.84138 6 8.84138C6.38761 8.84138 6.70312 9.15689 6.70312 9.5445C6.70312 9.93211 6.38761 10.2476 6 10.2476ZM6.70312 7.43513C6.70312 7.82274 6.38761 8.13825 6 8.13825C5.61239 8.13825 5.29687 7.82274 5.29687 7.43513V3.9195C5.29687 3.53189 5.61239 3.21638 6 3.21638C6.38761 3.21638 6.70312 3.53189 6.70312 3.9195V7.43513Z" fill="currentColor"/>
                                </svg>
                               <span> ${data['weeklyTipText']}</span>
                            </div>`;
		} else if (data['is_hotel_personally_verified']) {
			html += ` <div class="c-tk-deal-card__labels-item c-tk-deal-card__labels-item--green">
                                <svg width="14" height="12" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5368 2.43875L8.29888 4.72918L6.20964 0.365968C6.18897 0.286089 6.09896 0.222951 6.01228 0.204622V0.199219C6.00315 0.199219 5.99415 0.199611 5.9853 0.200376C5.97777 0.199611 5.97032 0.199219 5.96302 0.199219C5.86437 0.199219 5.76572 0.270683 5.71639 0.365968L3.64763 4.68642L0.463275 2.43875C0.364625 2.36729 0.21665 2.36729 0.118 2.43875C0.0193504 2.51022 -0.0299745 2.62932 0.0193504 2.74843L2.05213 8.14202C2.0566 8.18167 2.06881 8.21866 2.09101 8.25083C2.12871 8.30545 2.19521 8.34615 2.26851 8.36231C2.29049 8.36756 2.31359 8.37027 2.33762 8.37027H3.15156H7.98533H9.66245C9.78577 8.37027 9.88442 8.2988 9.93374 8.1797L11.9807 2.74843C12.0301 2.62932 11.9807 2.51022 11.8821 2.43875C11.7834 2.36729 11.6355 2.36729 11.5368 2.43875ZM3.10218 9.79906H8.89786C9.04583 9.79906 9.16915 9.67995 9.16915 9.5132C9.16915 9.34645 9.02117 9.22734 8.8732 9.22734H3.10218C2.92954 9.22734 2.80623 9.34645 2.80623 9.5132C2.80623 9.67995 2.9542 9.79906 3.10218 9.79906Z" fill="currentColor"></path>
                                </svg>

                               <span> ${data['personally_verified_label']}</span>
                            </div>`;
		}

		if (data['has_longer_validity']) {
			html += `<div class="c-tk-deal-card__labels-item c-tk-deal-card__labels-item--green">
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <path d="M4.50307 0V1.00103H5.5041V1.50153C5.85445 1.45149 6.15475 1.45149 6.50512 1.50153V1.00103H7.50615V0H4.50307Z" fill="currentColor"></path>
                                        <path d="M9.40768 3.30453L9.75803 2.95418L10.1585 3.3546L10.8592 2.65387L9.35764 1.15234L8.65692 1.85307L9.05733 2.25346L8.60688 2.70392C6.20443 1.25243 3.10126 2.0032 1.69983 4.40565C0.298413 6.80809 1.04916 9.81116 3.40156 11.2626C5.75397 12.7141 8.85712 11.9634 10.2586 9.56092C11.5098 7.50882 11.1595 4.90617 9.40768 3.30453ZM6.00421 10.4618C4.05222 10.4618 2.50064 8.91026 2.50064 6.95827C2.50064 5.00628 4.05222 3.45468 6.00421 3.45468V6.95825H9.50777C9.50779 8.91024 7.9562 10.4618 6.00421 10.4618Z" fill="currentColor"></path>
                                    </g>
                                </svg>

                                <span>${data['has_longer_validity_label']}</span>
                            </div>`;
		}

		html += '</div>';

		return html;
	}

	buildVerificationLabels(data) {
		if (data['hasChangeReservationDays'] && data['hasCancellationReservationDays']) {
			return `<div class="c-tk-deal-card__verified">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.6112 7.05714L14.52 5.9661C14.261 5.70711 14.0488 5.19531 14.0488 4.82827V3.28527C14.0488 2.55127 13.4492 1.95165 12.7154 1.95126H11.1717C10.8051 1.95126 10.2927 1.73864 10.0337 1.47984L8.94267 0.388806C8.42426 -0.129602 7.57545 -0.129602 7.05704 0.388806L5.96601 1.48062C5.70678 1.73961 5.1938 1.95165 4.82798 1.95165H3.28498C2.55195 1.95165 1.95155 2.55127 1.95155 3.28527V4.82831C1.95155 5.1939 1.73936 5.70731 1.48033 5.96614L0.389099 7.05718C-0.1297 7.57559 -0.1297 8.42439 0.389099 8.94362L1.48033 10.0347C1.73952 10.2936 1.95155 10.8069 1.95155 11.1725V12.7155C1.95155 13.4487 2.55195 14.0492 3.28498 14.0492H4.82801C5.19462 14.0492 5.70702 14.2613 5.96604 14.5202L7.05708 15.6116C7.57549 16.1296 8.4243 16.1296 8.9427 15.6116L10.0337 14.5202C10.293 14.2612 10.8052 14.0492 11.1718 14.0492H12.7154C13.4492 14.0492 14.0488 13.4487 14.0488 12.7155V11.1725C14.0488 10.8053 14.2612 10.2935 14.52 10.0347L15.6113 8.94362C16.1293 8.42439 16.1293 7.57555 15.6112 7.05714ZM6.94145 11.0002L3.9996 8.05798L4.94243 7.11534L6.94169 9.1146L11.0572 5.00011L11.9998 5.94274L6.94145 11.0002Z" fill="currentColor"></path>
                            </svg>

                            ${data['changeAndCancellationLabel']}
                        </div>`;
		} else {
			if (data['hasChangeReservationDays']) {
				return `<div class="c-tk-deal-card__verified">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.6112 7.05714L14.52 5.9661C14.261 5.70711 14.0488 5.19531 14.0488 4.82827V3.28527C14.0488 2.55127 13.4492 1.95165 12.7154 1.95126H11.1717C10.8051 1.95126 10.2927 1.73864 10.0337 1.47984L8.94267 0.388806C8.42426 -0.129602 7.57545 -0.129602 7.05704 0.388806L5.96601 1.48062C5.70678 1.73961 5.1938 1.95165 4.82798 1.95165H3.28498C2.55195 1.95165 1.95155 2.55127 1.95155 3.28527V4.82831C1.95155 5.1939 1.73936 5.70731 1.48033 5.96614L0.389099 7.05718C-0.1297 7.57559 -0.1297 8.42439 0.389099 8.94362L1.48033 10.0347C1.73952 10.2936 1.95155 10.8069 1.95155 11.1725V12.7155C1.95155 13.4487 2.55195 14.0492 3.28498 14.0492H4.82801C5.19462 14.0492 5.70702 14.2613 5.96604 14.5202L7.05708 15.6116C7.57549 16.1296 8.4243 16.1296 8.9427 15.6116L10.0337 14.5202C10.293 14.2612 10.8052 14.0492 11.1718 14.0492H12.7154C13.4492 14.0492 14.0488 13.4487 14.0488 12.7155V11.1725C14.0488 10.8053 14.2612 10.2935 14.52 10.0347L15.6113 8.94362C16.1293 8.42439 16.1293 7.57555 15.6112 7.05714ZM6.94145 11.0002L3.9996 8.05798L4.94243 7.11534L6.94169 9.1146L11.0572 5.00011L11.9998 5.94274L6.94145 11.0002Z" fill="currentColor"></path>
                                </svg>

                                ${data['changeReservationDaysLabel']}
                            </div>`;
			}

			if (data['hasCancellationReservationDays']) {
				return `<div class="c-tk-deal-card__verified">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.6112 7.05714L14.52 5.9661C14.261 5.70711 14.0488 5.19531 14.0488 4.82827V3.28527C14.0488 2.55127 13.4492 1.95165 12.7154 1.95126H11.1717C10.8051 1.95126 10.2927 1.73864 10.0337 1.47984L8.94267 0.388806C8.42426 -0.129602 7.57545 -0.129602 7.05704 0.388806L5.96601 1.48062C5.70678 1.73961 5.1938 1.95165 4.82798 1.95165H3.28498C2.55195 1.95165 1.95155 2.55127 1.95155 3.28527V4.82831C1.95155 5.1939 1.73936 5.70731 1.48033 5.96614L0.389099 7.05718C-0.1297 7.57559 -0.1297 8.42439 0.389099 8.94362L1.48033 10.0347C1.73952 10.2936 1.95155 10.8069 1.95155 11.1725V12.7155C1.95155 13.4487 2.55195 14.0492 3.28498 14.0492H4.82801C5.19462 14.0492 5.70702 14.2613 5.96604 14.5202L7.05708 15.6116C7.57549 16.1296 8.4243 16.1296 8.9427 15.6116L10.0337 14.5202C10.293 14.2612 10.8052 14.0492 11.1718 14.0492H12.7154C13.4492 14.0492 14.0488 13.4487 14.0488 12.7155V11.1725C14.0488 10.8053 14.2612 10.2935 14.52 10.0347L15.6113 8.94362C16.1293 8.42439 16.1293 7.57555 15.6112 7.05714ZM6.94145 11.0002L3.9996 8.05798L4.94243 7.11534L6.94169 9.1146L11.0572 5.00011L11.9998 5.94274L6.94145 11.0002Z" fill="currentColor"></path>
                                </svg>

                                ${data['cancellationReservationDaysLabel']}
                            </div>`;
			}
		}

		return '';
	}


	buildCircleLabels(data) {
		if (! data['labels_circle'] || ! Object.keys(data['labels_circle']).length) {
			return '';
		}

		let html = '';
		for (let key in data['labels_circle']) {
			if (! data['labels_circle'].hasOwnProperty(key)) {
				continue;
			}

			let label = data['labels_circle'][key];
			html += `
				<div class="c-label-circle" style="${label['styles']}">
					<span class="c-label-circle__inside">
						${label['text']}
						<span class="icon-svg icon-svg__icon-voucher c-label-circle__icon" aria-hidden="true">
							<svg class="icon-svg__svg" viewBox="0 0 22 22" width="22" height="22">
								<use xlink:href="${label['icon']}"></use>
							</svg>
						</span>
					</span>
				</div>
			`;
		}

		return html;
	}

	buildIconsHTML(data) {
		let html = '';
		for (let key in data['icons']) {
			if (! data['icons'].hasOwnProperty(key)) {
				continue;
			}

			let icon = data['icons'][key];
			html += `
				<span class="c-icon-with-text">
					<span class="icon-svg" aria-hidden="true">
						<svg class="icon-svg__svg" viewBox="0 0 16 16" width="16" height="16">
							<use xlink:href="${icon['icon']}"></use>
						</svg>
					</span>
					<span class="c-icon-with-text__text">${icon['text']}</span>
				</span>
			`;
		}

		return html;
	}

	buildPrices(data) {
		let html = '<div class="c-tk-deal-card__price c-tk-price">';

		if (data['price_before_only_number'] && data['price_before_number']) {
			html += `<span class="c-tk-price__discount">- ${data["discount_percentage"]}%</span>`;
		}

		html += '<div class="c-tk-deal-card__price_wrapper">';

		html += `<span class="c-tk-price__new">${data['price_after']}</span>`;

		if (data['price_before_number']) {
			html += `<span class="c-tk-price__old">${data['price_before_number']}</span>`;
		}

		html += `</div>`;
		html += `</div>`;

		return html;
	}

	buildFavorite(data) {
		let html = '<div class="c-tk-deal-card__favourite">';

		html += `<button type="button" class="c-tk-button c-tk-button--favourite c-tk-button--favourite-red c-tk-tooltip js-favorite ${data['is_favorite'] ? 'is-favorite' : 'u-hidden'}" data-url="${data['favorite_url']}" data-type="remove" data-id="${data['id']}" data-object="${data['favorite_object']}">
					<span class="icon-svg icon-svg__icon-heart" aria-hidden="true">
						<svg class="icon-svg__svg" viewBox="0 0 20 20" width="20" height="20">
							<use xlink:href="./assets/icons/svg-sprite2.svg#icon-heart-full"></use>
						</svg>
					</span>
						<span class="c-tk-tooltip__box c-tk-tooltip__box--left">
						<span class="c-tk-tooltip__text">${data['favorite_remove_text']}</span>
						<span class="c-tk-tooltip__arrow"></span>
					</span>
				</button>

				<button type="button" class="c-tk-button c-tk-button--favourite c-tk-tooltip js-favorite ${!data['is_favorite'] ? 'is-favorite' : 'u-hidden'}" data-url="${data['favorite_url']}" data-type="add" data-id="${data['id']}" data-object="${data['favorite_object']}">
					<span class="icon-svg icon-svg__icon-heart" aria-hidden="true">
						<svg class="icon-svg__svg" viewBox="0 0 20 20" width="20" height="20">
							<use xlink:href="./assets/icons/svg-sprite2.svg#icon-heart"></use>
						</svg>
					</span>
					<span class="c-tk-tooltip__box c-tk-tooltip__box--left">
						<span class="c-tk-tooltip__text">${data['favorite_add_text']}</span>
						<span class="c-tk-tooltip__arrow"></span>
					</span>
				</button>`;

		html += `</div>`;

		return html;
	}

	buildPersonallyVerified(data) {
		if (! data['is_hotel_personally_verified']) {
			return '';
		}

		return `
			<div class="c-deal-card__verified"><span class="icon-svg icon-svg__icon-king" aria-hidden="true">
					<svg class="icon-svg__svg" viewBox="0 0 22 22" width="22" height="22">
						<use xlink:href="./assets/icons/svg-sprite2.svg#icon-king"></use>
					</svg>
				</span>
				<span class="u-font-weight-bold u-font-size-90-percent">${data['personally_verified_label']}</span>
			</div>
		`;
	}

	buildReviews(data) {
		if (! data['review_public']) {
			return '';
		}

		return `
			<div class="c-deal-card__rating c-icon-with-text">
				<span class="icon-svg icon-svg__icon-star-score-outline u-color-secondary" aria-hidden="true">
					<svg class="icon-svg__svg" viewBox="0 0 16 16" width="16" height="16">
						<use xlink:href="./assets/icons/svg-sprite2.svg#icon-star-score-outline"></use>
					</svg>
				</span>
				<span class="c-icon-with-text__text">${data['review_public']}</span>
			</div>
		`;
	}

	buildCancelChangeReservationDays(data) {
		if (data['hasCancellationReservationDays']) {
			return `<p class="c-deal-card__text u-color-primary">${data['cancellationReservationDaysLabel']}</p>`;
		}

		if (data['hasChangeReservationDays']) {
			return `<p class="c-deal-card__text u-color-primary">${data['changeReservationDaysLabel']}</p>`;
		}

		return '';
	}

	buildStaffReview(data) {
		let self = this;

		return '';

		return `
			<div class="col-lg--16-16 col-md--16-16">
				<div class="c-review-banner u-base-offset-bottom">
        			<div class="c-review-banner__deal">
					<article class="c-deal-card">
						<a class="c-deal-card__flex" href="${data['link']}">
							<div class="c-deal-card__top">
								<header class="c-deal-card__header">
									<figure class="c-deal-card__image c-lazy-image">
										<img class="c-lazy-image__placeholder" src="${data['image_lazy']}" alt="${data['image_alt']}">
										<img class="c-lazy-image__image js-lazy-image" data-src="${data['image_src']}" data-srcset="${data['image_srcset']}" alt="${data['alt']}">
										<noscript>
											<img src="${data['image_src']}" alt="${data['alt']}">
										</noscript>
									</figure>
									${self.buildLabels(data)}
									${self.buildCircleLabels(data)}
									${self.buildPrices(data)}
								</header>
								<div class="c-deal-card__content">
									<h2 class="c-deal-card__headline">${data['miniName']}</h2>
									<p class="c-deal-card__sub-headline">${data['hotelName']}</p>
									<p class="c-deal-card__location c-icon-with-text">
										<span class="icon-svg" aria-hidden="true">
											<svg class="icon-svg__svg" viewBox="0 0 22 22" width="22" height="22">
												<use xlink:href="${data['location_icon']}"></use>
											</svg>
										</span>
										<span class="c-icon-with-text__text">${data['location_text']}</span>
									</p>

									${self.buildReviews(data)}

									${self.buildCancelChangeReservationDays(data)}
								</div>
							</div>
							<footer class="c-deal-card__footer">
								${self.buildIconsHTML(data)}
							</footer>
						</a>
					</article>
				</div>
					<div class="c-review-banner__content">
					<header class="c-review-banner__header">
						<span class="c-tip c-tip--big c-tip--no-offset c-tip--primary">
							<span class="c-tip__text">${data['banner']['data']['label']}</span>
							<span class="c-tip__arrow"></span>
						</span>
					</header>
					<p class="c-review-banner__message" style="font-size: 18px"><i>"${data['banner']['data']['review']}”</i></p>
					<footer class="c-review-banner__footer">
						<div class="c-review-banner__author">
							<img src="${data['banner']['data']['avatar']}" width="65" height="65">
							<div class="c-review-banner__author-info" style="padding-left: 12px">
								<strong>${data['banner']['data']['user']}</strong><br>
								<span>${data['banner']['data']['position']}</span></div>
						</div>
					</footer>
				</div>
				</div>
			</div>
		`;
	}

	buildInterestingAbout(data) {
		let self = this;

		return '';

		return `
			<div class="col-lg--16-16 col-md--16-16">
				<div class="c-review-banner u-base-offset-bottom">
					<div class="c-review-banner__deal">
						<article class="c-deal-card">
							<a class="c-deal-card__flex" href="${data['link']}">
								<div class="c-deal-card__top">
									<header class="c-deal-card__header">
										<figure class="c-deal-card__image c-lazy-image">
											<img class="c-lazy-image__placeholder" src="${data['image_lazy']}" alt="${data['image_alt']}">
											<img class="c-lazy-image__image js-lazy-image" data-src="${data['image_src']}" data-srcset="${data['image_srcset']}" alt="${data['alt']}">
											<noscript>
												<img src="${data['image_src']}" alt="${data['alt']}">
											</noscript>
										</figure>
										${self.buildLabels(data)}
										${self.buildCircleLabels(data)}
										${self.buildPrices(data)}
									</header>
									<div class="c-deal-card__content">
										<h2 class="c-deal-card__headline">${data['miniName']}</h2>
										<p class="c-deal-card__sub-headline">${data['hotelName']}</p>
										<p class="c-deal-card__location c-icon-with-text">
											<span class="icon-svg" aria-hidden="true">
												<svg class="icon-svg__svg" viewBox="0 0 22 22" width="22" height="22">
													<use xlink:href="${data['location_icon']}"></use>
												</svg>
											</span>
											<span class="c-icon-with-text__text">${data['location_text']}</span>
										</p>

										${self.buildReviews(data)}

										${self.buildCancelChangeReservationDays(data)}
									</div>
								</div>
								<footer class="c-deal-card__footer">
									${self.buildIconsHTML(data)}
								</footer>
							</a>
						</article>
					</div>
					<div class="c-review-banner__content">
						<header class="c-review-banner__header">
							<span class="c-tip c-tip--big c-tip--no-offset c-tip--primary">
								<span class="c-tip__text">${data['banner']['data']['label']}</span>
								<span class="c-tip__arrow"></span>
							</span>
						</header>
						<p class="c-floating-banner__message" style="font-size: 18px">${data['banner']['data']['text']}</p>
						<footer class="c-review-banner__footer">
						</footer>
					</div>
				</div>
			</div>
		`;
	}

	buildCustomerReview(data) {
		let self = this;

		return '';

		return `
			<div class="col-lg--16-16 col-md--16-16">
				<div class="c-review-banner u-base-offset-bottom">
        			<div class="c-review-banner__deal">
					<article class="c-deal-card">
						<a class="c-deal-card__flex" href="${data['link']}">
							<div class="c-deal-card__top">
								<header class="c-deal-card__header">
									<figure class="c-deal-card__image c-lazy-image">
										<img class="c-lazy-image__placeholder" src="${data['image_lazy']}" alt="${data['image_alt']}">
										<img class="c-lazy-image__image js-lazy-image" data-src="${data['image_src']}" data-srcset="${data['image_srcset']}" alt="${data['alt']}">
										<noscript>
											<img src="${data['image_src']}" alt="${data['alt']}">
										</noscript>
									</figure>
									${self.buildLabels(data)}
									${self.buildCircleLabels(data)}
									${self.buildPrices(data)}
								</header>
								<div class="c-deal-card__content">
									<h2 class="c-deal-card__headline">${data['miniName']}</h2>
									<p class="c-deal-card__sub-headline">${data['hotelName']}</p>
									<p class="c-deal-card__location c-icon-with-text">
										<span class="icon-svg" aria-hidden="true">
											<svg class="icon-svg__svg" viewBox="0 0 22 22" width="22" height="22">
												<use xlink:href="${data['location_icon']}"></use>
											</svg>
										</span>
										<span class="c-icon-with-text__text">${data['location_text']}</span>
									</p>

									${self.buildReviews(data)}

									${self.buildCancelChangeReservationDays(data)}
								</div>
							</div>
							<footer class="c-deal-card__footer">
								${self.buildIconsHTML(data)}
							</footer>
						</a>
					</article>
				</div>
					<div class="c-review-banner__content">
						<header class="c-review-banner__header">
							<span class="c-tip c-tip--big c-tip--no-offset c-tip--secondary">
								<span class="c-tip__text">${data['banner']['data']['label']}</span>
								<span class="c-tip__arrow"></span>
							</span>
						</header>
						<p class="c-floating-banner__message" style="font-size: 18px"><i>"${data['banner']['data']['review']}”</i></p>
						<footer class="c-review-banner__footer">
							<header class="c-deal-new-ratings__rating-header">
								<div class="c-deal-new-rating__stars">
									<div class="c-deal-new-rating__stars--active" style="width: ${data['banner']['data']['percent']}%"><i></i><i></i><i></i><i></i><i></i></div>
									<div class="c-deal-new-rating__stars--inactive" style="width: ${100 - data['banner']['data']['percent']}%"><i></i><i></i><i></i><i></i><i></i></div>
								</div>
								<strong class="c-deal-new-ratings__rating-header-number">${data['banner']['data']['rating']}/5</strong>
								<div class="c-deal-new-ratings__rating-header-name">
									(${data['banner']['data']['name']} - <img src="${data['banner']['data']['country_image']}" class="c-comment__rating-flag"> ${data['banner']['data']['country_label']})
								</div>
							</header>
						</footer>
					</div>
				</div>
			</div>
		`;
	}

	buildArticleBanner(data) {
		return `
		<div class="col-lg--12-12 col-md--12-12">
			<div class="c-banner c-banner--vertical c-banner--vertical-img c-banner--white u-base-offset-bottom">
				<a class="c-banner__link" href="${data['data']['link']}">
					<div class="c-banner__header">
						<img class="c-banner__img" src="${data['data']['article_image']}">
					</div>
					<div class="c-banner__content">
						<span class="c-tip c-tip--big c-tip--no-offset c-tip--green">
							<span class="c-tip__text">${data['data']['label']}</span>
							<span class="c-tip__arrow"></span>
						</span>
						<h3 class="c-banner__title c-banner__title u-text-underline">
							${data['data']['title']}
						</h3>
					</div>
				</a>
			</div>
		</div>
		`;
	}

	buildCancellationTexts(data) {
		if (!data['hasCancellationReservationDays'] && !data['hasChangeReservationDays']) {
			return '';
		}

		let html = '';

		if (data['hasCancellationReservationDays']) {
			html += '<div class="c-tk-deal-card__verified">';
			html += `<svg class="icon-svg__svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<use xlink:href="/dist/assets/icons/svg-sprite2.svg#icon-verified"></use>
					</svg>`;
			html += `<span>${data['cancellationReservationDaysLabel']}</span>`
			html += '</div>'
		}

		if (data['hasChangeReservationDays']) {
			html += '<div class="c-tk-deal-card__verified">';
			html += `<svg class="icon-svg__svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<use xlink:href="/dist/assets/icons/svg-sprite2.svg#icon-verified"></use>
					</svg>`;
			html += `<span>${data['changeReservationDaysLabel']}</span>`
			html += '</div>'
		}

		html += '</div>'

		return html;
	}
}
